var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 17.7143C21.5025 17.7143 22 18.226 22 18.8571C22 19.4883 21.5025 20 20.8889 20H3.11111C2.49746 20 2 19.4883 2 18.8571C2 18.226 2.49746 17.7143 3.11111 17.7143H20.8889ZM20.8889 10.8571C21.5025 10.8571 22 11.3688 22 12C22 12.6312 21.5025 13.1429 20.8889 13.1429H3.11111C2.49746 13.1429 2 12.6312 2 12C2 11.3688 2.49746 10.8571 3.11111 10.8571H20.8889ZM20.8889 4C21.5025 4 22 4.51167 22 5.14286C22 5.77404 21.5025 6.28571 20.8889 6.28571H3.11111C2.49746 6.28571 2 5.77404 2 5.14286C2 4.51167 2.49746 4 3.11111 4H20.8889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.509e5c48a6f265e48e26d4c71fe25dcb.svg";
export { ForwardRef as ReactComponent };